module.exports = __webpack_public_path__ + "img/comment.add7a641.svg";